"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("./util/runtypeImplementing");
exports.Message = (0, runtypeImplementing_1.runtypeImplementing)()((0, runtypes_1.Record)({
    uuid: runtypes_1.String,
    timestamp: runtypes_1.Number,
    application: runtypes_1.String,
    payload: runtypes_1.Unknown,
}));
//# sourceMappingURL=Message.js.map